export default __webpack_public_path__ + "static/lineto-circular-book-c-141aa719c8fcb6dd8beb555816705445.woff";